<template>
  <div class="step1-flex-grid">
    <aside class="step1-col step1-sidebar">
      <div class="premium-container">
        <p class="form-title-text">💼 CATEGORIES</p>
      </div>

      <p class="form-info-text" style="margin: 0rem;">
        Niche, role, profession...
      </p>

      <div class="input-select-container">
        <select class="input-container input-container-medium" style="margin-right:0rem;" v-model="sitesFilter.niche">
          <option value="">All</option>
          <option v-for="(s, index) in listSitesFilterNiche" :value="s" :key="`listSitesFilterNiche-${index}`">{{ s }}</option>
        </select>
      </div>

      <div class="premium-container">
        <p class="form-title-text">🌎 WHERE</p>
      </div>
      <div class="input-select-container">
        <select class="input-container input-container-medium" style="margin-right:0rem;" v-model="sitesFilter.country">
          <option value="">All</option>
          <option v-for="(s, index) in listSitesFilterCountry" :value="s" :key="`listSitesFilterCountry-${index}`">{{ s }}</option>
        </select>
      </div>

      <div class="premium-container">
        <p class="form-title-text">🔍 KEYWORDS</p>
      </div>
      <div class="input-select-container">
        <input
          class="input-container input-container-medium"
          style="width: 100%;"
          placeholder="Type to search keywords"
          v-model="sitesFilter.text"
        />
      </div>

      <div class="step1-sticky">
        <button @click="clearSiteFilter()" class="secondary-button medium-button" style="width: 100%;" type="button">
          Clear all filters
          <i class="fas fa-times-circle delete-button"></i>
        </button>
      </div>
    </aside>

    <section class="step1-col step1-main" ref="scroll">
      <div class="step1-site-selector-container">
        <div class="step1-site-selector" :key="`filtered-sites-${i}`" v-for="(site, i) in womp">
          <div class="website-name-container">
            <div class="dashboard-image-icon-container">
              <img class="image-hero" :src="site.logoUrl" />
            </div>
            &nbsp;
            <p class="dashboard-details-site-name">{{ site.name }}</p>
            <i @mouseover="site._active = true" @mouseleave="site._active = false" class="fas fa-info-circle info-button"></i>
          </div>

          <div v-if="site._active" class="tooltiptext info-container">
            <p class="info-text">{{ site.description }}</p>
          </div>

          <p class="form-title-text">💼 Categories</p>
          <p class="step1-selector-text">{{ site.niche }}</p>

          <p class="form-title-text">🌎 Where</p>
          <p class="step1-selector-text">{{ site.country }}</p>

          <p class="form-title-text">🔍 Keywords</p>
          <p class="step1-selector-text">{{ site.tags.join(", ") }}</p>

          <button v-if="showAddButton" @click="addSite(site)" class="primary-button small-button step1-selector-add-button" type="button">
            Add <i class="fas fa-plus-circle delete-button"></i>
          </button>
          <button
            v-if="showDetailButton"
            @click="$router.push({ path: `/site/${site.id.split(' ').join('-')}` })"
            class="primary-button small-button step1-selector-add-button"
            type="button"
          >
            🔎 Details
          </button>
        </div>

        <div @click="$router.push({ path: '/suggest-site' })" class="step1-site-selector-unlock-more">
          <p class="dashboard-details-site-name">
            🔎 Can't find your favourite site?
          </p>

          <button
            @click="$router.push({ path: '/suggest-site' })"
            class="tertiary-button small-button step1-selector-add-button"
            type="button"
          >
            Suggest a new site
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import types from "@/types";
import utils from "@/utils";
import firebase from "@/firebase";

export default {
  props: {
    initialSelectedSites: {
      required: true,
      default: () => [],
      type: Array,
    },
    hasFilter: {
      required: true,
      type: Boolean,
      default: false,
    },
    showDetailButton: {
      required: true,
      type: Boolean,
      default: false,
    },
    showAddButton: {
      required: true,
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      initialElement: 20,
      maxElements: 20,
      selectedSites: this.initialSelectedSites,
      sites: [],
      sitesFilter: {
        region: "",
        niche: "",
        country: "",
        text: "",
      },
    };
  },

  mounted() {
    const element = this.$refs.scroll;
    element.addEventListener("scroll", this.onScroll);
  },

  beforeUnmount() {
    const element = this.$refs.scroll;
    element.removeEventListener("scroll", this.onScroll);
  },

  methods: {
    onScroll() {
      const element = this.$refs.scroll;
      if (element.scrollHeight - element.scrollTop === element.clientHeight) {
        this.loadMore();
      }
    },

    loadMore() {
      this.initialElement += this.maxElements;
    },

    loadLess() {
      console.log("load less");
      if (this.initialElement - this.maxElements < 0) {
        this.initialElement = 0;
        return;
      }
      this.initialElement -= this.maxElements;
    },

    async getSites() {
      let query = firebase.firestore.collection("sites");
      if (this.hasFilter) {
        query = query.where("postingType", "==", types.sitesType.jobboardyReady);
      }

      query
        .get()
        .then((snap) => {
          const promises = snap.docs.map(async (s) => {
            const site = s.data();
            site.id = s.id;
            site.logoUrl = await utils.getUrlFromPath(site.logoPath);
            this.sites.push(site);
          });

          Promise.all(promises);

          this.$emit("selected-sites", this.selectedSites);
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },

    addSite(site) {
      for (const s of this.selectedSites) {
        if (s.id === site.id) {
          return;
        }
      }
      const selectedSites = [].concat(this.selectedSites);
      selectedSites.push(site);
      this.selectedSites = selectedSites;
      this.$emit("selected-sites", this.selectedSites);
    },

    removeSite(site) {
      for (let i = 0; i < this.selectedSites.length; i++) {
        const s = this.selectedSites[i];
        if (s.id === site.id) {
          this.selectedSites.splice(i, 1);
        }
      }
      this.$emit("selected-sites", this.selectedSites);
    },
  },

  computed: {
    womp() {
      return this.filteredSites.slice(0, this.initialElement);
    },

    filteredSites() {
      let aux = this.sites;
      if (this.sitesFilter.niche !== "") {
        aux = this.sites.filter((x) => {
          for (const addedSite of this.selectedSites) {
            if (x.id == addedSite.id) {
              return false;
            }
          }

          return x.niche.includes(this.sitesFilter.niche);
        });
      }

      if (this.sitesFilter.country !== "") {
        aux = aux.filter((x) => {
          return x.country.includes(this.sitesFilter.country);
        });
      }

      if (this.sitesFilter.region !== "") {
        aux = aux.filter((x) => {
          if (x.region == null) {
            return false;
          }
          return x.region.includes(this.sitesFilter.region);
        });
      }

      if (this.sitesFilter.text !== "") {
        const lowerText = this.sitesFilter.text.toLowerCase();
        aux = aux.filter((x) => {
          if (x.name.toLowerCase().includes(lowerText)) {
            return true;
          }
          for (const t of x.tags) {
            if (t.toLowerCase().includes(lowerText)) {
              return true;
            }
          }
          return false;
        });
      }

      aux = aux.filter((x) => {
        for (const s of this.selectedSites) {
          if (x.id === s.id) {
            return false;
          }
        }
        return true;
      });

      return aux;
    },
    listSitesFilterNiche() {
      const a = this.sites.map((x) => x.niche);
      return a.filter((item, pos) => a.indexOf(item) == pos).filter((x) => x != null && x != "");
    },
    listSitesFilterCountry() {
      const a = this.sites.map((x) => x.country);
      return a.filter((item, pos) => a.indexOf(item) == pos).filter((x) => x != null && x != "");
    },
    listSitesFilterRegion() {
      const a = this.sites.map((x) => {
        if (x.region != null) {
          return x.region;
        }
      });
      return a.filter((item, pos) => a.indexOf(item) == pos).filter((x) => x != null && x != "");
    },
  },
};
</script>

<style></style>
